import React, { useId } from "react";
import TextInput, { TextInputProps } from "@/component/input/TextInput";


type TextInputGroupProps = Omit<TextInputProps, "onChange"> & {
    rowGap?: number;
    label?: string;
    invalidText?: string;
    "aria-describedby"?: string;
    onChange: (value: string) => void;
}

const TextInputGroup: React.FC<TextInputGroupProps> = (props) => {
    const {
        label,
        invalidText,
        onChange,
        rowGap = 6,
        "aria-describedby": externalDescribedBy,
        "aria-errormessage": externalErrorMessageId,
        ...rest
    } = props;

    const id = useId();
    const errorId = externalErrorMessageId ?? id;

    return (
        <div className="w-full flex flex-col" style={{ rowGap }}>
            {label && (
                <div className="field-label">
                    {label}
                </div>
            )}

            <div className="flex flex-col gap-1">
                <TextInput onChange={e => onChange(e.target.value)}
                           aria-describedby={externalDescribedBy}
                           aria-errormessage={props.invalid ? errorId : undefined}
                           {...rest}
                />
                {props.invalid && (
                    <span id={errorId}
                          className="text-invalid"
                    >
                        {invalidText}
                    </span>
                )}
            </div>
        </div>
    );
};

export default TextInputGroup;